var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3137 10.5857L13.4142 0.686186C13.0391 0.311113 12.5304 0.1004 12 0.1004C11.4696 0.1004 10.9609 0.311113 10.5858 0.686186L0.686292 10.5857C0.311218 10.9608 0.100505 11.4695 0.100505 11.9999C0.100506 12.5303 0.311219 13.039 0.686292 13.4141L10.5858 23.3136C11.3636 24.0914 12.6364 24.0914 13.4142 23.3136L23.3137 13.4141C24.0915 12.6363 24.0915 11.3635 23.3137 10.5857ZM14.1213 15.5354L12 13.4141L9.87868 15.5354C9.48977 15.9243 8.85338 15.9243 8.46447 15.5354C8.07556 15.1465 8.07556 14.5101 8.46447 14.1212L10.5858 11.9999L8.46447 9.87857C8.07556 9.48967 8.07556 8.85327 8.46447 8.46436C8.85338 8.07545 9.48977 8.07545 9.87868 8.46436L12 10.5857L14.1213 8.46436C14.5102 8.07545 15.1466 8.07545 15.5355 8.46436C15.9244 8.85327 15.9244 9.48967 15.5355 9.87857L13.4142 11.9999L15.5355 14.1212C15.9244 14.5101 15.9244 15.1465 15.5355 15.5354C15.1466 15.9243 14.5102 15.9243 14.1213 15.5354Z",
    fill: "#F1406B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.3ffb8b35b7c9edae8f6abab1ccec556c.svg";
export { ForwardRef as ReactComponent };